import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from '../state/app-state';
import { ReceivingState } from '../state/receiving-state';


//const ReceivingDetails = (state: AppState) => state.Receiving;
const ReceivingDetails = createFeatureSelector<ReceivingState>('Receiving');
export const selectReceivingSucsess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingSuccess);
export const selectReceivingDetailid = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingDetailById);
export const selectReceivingDetailByidSuccess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingDetailByIdSucess);
export const selectReceivingSearch = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingSearch);
export const selectReceivingViewModel = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingViewModel);
export const selectReceivingSorting = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetReceivingSorting);
export const selectReceivingPoSearch = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetPoSearchbyId);
export const selectLookupDetailSuccess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetLookUpDetailSuccess);
export const selectLookupGridDetails = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetLookUpGridSuccess);
export const selectItemListDetails = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetItemListSuccess);
export const selectSupplierItemNumber = createSelector(ReceivingDetails, (state: ReceivingState) =>
    state['Receiving'].GetSupplierItemNumberSuccess);
export const selectSuplierSuccess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetSupplierSuccess);
export const selectSuplierList = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetSearchSupplier);
export const selectLocationList = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetLocationSuccess);
export const ReceivingSucess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].PostReceivingSuccess);
export const ReceivingSavedSuccess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].SaveReceivingSucess);
export const ReceivingFormDetailSuccess = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].ReceivingformDetails);
export const GetReceivingPoSumary = createSelector(ReceivingDetails, (state: ReceivingState) =>
state['Receiving'].GetItemPoSummarySuccess);